import './user-pages.sass';
import axios from 'axios';
import { useState } from 'react';
import useAlert from '../hooks/useAlert';
import useConfirm from '../hooks/useConfirm';
import { PayPalButton } from 'react-paypal-button-v2'; 
import { useTranslation } from 'react-i18next';

const Exchange = () => {
	const { t, i18n } = useTranslation();
	const { sendAlert } = useAlert();
	const token = localStorage.getItem('token');
	const { sendConfirm } = useConfirm();

	const [form, setForm] = useState({
		redeemCode: '',
	});

	const { redeemCode } = form;

	const inputChange = (event, field) => {
		setForm({ ...form, [field]: event.target.value });
	}

	const checkForm = (event) => {
		event.preventDefault();
		let hasError = false;

		if (!redeemCode) {
			sendAlert(t('redeem.input_placeholder'));
			hasError = true;
		}

		if (!hasError) {
			sendConfirm({
				title: `${t('redeem.msg_hint')} ${redeemCode}`,
				onConfirm: submitForm,
			});
		}
	}

	const submitForm = () => {
		axios.post('/token/exchange', form, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then((response) => {
			const message = response.data.message;

			if (message === 'success') {
				sendAlert(t('redeem.msg_success'));
				setForm({
					redeemCode: '',
				});
			}
		}).catch((error) => {
			const message = error.response.data.message;
			switch (message) {
				case 'Invalid code':
					sendAlert(`${ form.redeemCode } ${ t('redeem.msg_invalid') }`);
					break;
				case 'This code has been used':
					sendAlert(`${ form.redeemCode } ${ t('redeem.msg_used') }`);
					break;
				default:
					sendAlert('Oops!', message);
					break;
			}
		});
	}

	return (
		<div id='Exchange' className='user-pages'>
			<div className='page-title'>{t('navbar.menu_redeem')}</div>
			{/* <div className='page-content' style={{ 'marginBottom': '10px' }}>您可以使用平台或合作夥伴提供的「兌換碼」兌換點數至您的錢包</div> */}
			<div className='page-content'>
				<form className='form' onSubmit={checkForm}>
					<div className='input-wrap'>
						<div className='label'>{t('redeem.input_title')}</div>
						{/* <input type='number' min='1' value={amountToExchange} onChange={(e) => { inputChange(e, 'amountToExchange') }} /> */}
						<input type='text' value={redeemCode} placeholder={t('redeem.input_placeholder')} onChange={e => inputChange(e, 'redeemCode')} />
					</div>
					<div className='button-wrap'>
						<button>{t('redeem.btn_submit')}</button>
					</div>
				</form>
			</div>

			<div className='paypal-button-wrap' style={{position: 'relative', zIndex: 1}}>
				{/* <PayPalButton
					amount={100}
					shippingPreference='NO_SHIPPING'
					onSuccess={(details) => {
						console.log('success');
						console.log(details);
					}}
					onError={(details) => {
						console.log('error');
						console.log(details);
					}}
					onCancel={(details) => {
						console.log('cancelled');
						console.log(details);
					}}
					options={{
						clientId: 'Ad4RxqYOpBH-z6EOnk8a8oS45kcDwOTwhLeS2RjT7rY9OjUUfXi3hQzhD-mbAe4QdxQJll7Z53zxxAbh',
						currency: 'TWD',

					}}
					style={{
						color: 'white',
						tagline: false,
					}}
				/> */}

				<div className='monetization-block'>Google ad</div>
			</div>
		</div>
	)
}

export default Exchange;